import { IconCrossLarge } from "central-icons";
import { useSystemAlert } from "@/hooks/use-system-alert";
import { cn } from "@/lib/utils";

const levelStyles = {
  critical:
    "bg-red text-white [&_button]:text-white [&_button:hover]:opacity-80",
  warning:
    "bg-golden-yellow text-black [&_button]:text-black [&_button:hover]:opacity-80",
  info: "bg-blue text-white [&_button]:text-white [&_button:hover]:opacity-80",
} as const;

export function SystemAlertBar() {
  const { systemAlert, isVisible, dismiss } = useSystemAlert();

  if (!(isVisible && systemAlert)) {
    return null;
  }

  return (
    <div
      className={cn(
        "fixed top-0 right-0 left-0 z-50 flex min-h-10 items-center justify-center gap-2 px-4 py-2 font-medium text-sm",
        levelStyles[systemAlert.level]
      )}
      role="alert"
    >
      <span className="flex-1 text-balance text-center">
        {systemAlert.message}
      </span>

      {systemAlert.is_dismissable && (
        <button
          className="shrink-0 rounded p-1 transition-opacity hover:opacity-80"
          onClick={dismiss}
          type="button"
        >
          <IconCrossLarge className="size-4" />
          <span className="sr-only">Dismiss</span>
        </button>
      )}
    </div>
  );
}
